import React, { Component } from "react";
import PropTypes from "prop-types";
import { format } from "d3-format";
import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";

import { isDefined, functor, getMALabel } from "../utils";
import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";

class MAEnvelopeTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }

  renderSVG(moreProps) {
    const { onClick, displayFormat, yAccessor, options, textFill, labelFill } =
      this.props;
    const { displayValuesFor } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);

    let top, middle, bottom;
    top = middle = bottom = "n/a";

    if (isDefined(currentItem) && isDefined(yAccessor(currentItem))) {
      const item = yAccessor(currentItem);
      top = displayFormat(item.top);
      middle = displayFormat(item.middle);
      bottom = displayFormat(item.bottom);
    }

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    const { period, movingAverageType, shiftType, shift } = options;
    // Get MA type label from centralized utility
    const maTypeLabel = getMALabel(movingAverageType);
    const shiftLabel = shiftType === "percent" ? `${shift}%` : `${shift}pts`;
    const tooltipLabel = `MA Env(${period}, ${maTypeLabel}, ${shiftLabel}): `;
    const tooltipValue = `${top}, ${middle}, ${bottom}`;

    return (
      <g
        transform={`translate(${x}, ${y})`}
        className={this.props.className}
        onClick={onClick}
        data-evo-id="tooltip-maenvelope"
      >
        <ToolTipText
          x={0}
          y={0}
          fontFamily={this.props.fontFamily}
          fontSize={this.props.fontSize}
        >
          <ToolTipTSpanLabel fill={labelFill}>{tooltipLabel}</ToolTipTSpanLabel>
          <tspan fill={textFill}>{tooltipValue}</tspan>
        </ToolTipText>
      </g>
    );
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

MAEnvelopeTooltip.propTypes = {
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  displayValuesFor: PropTypes.func,
  displayFormat: PropTypes.func.isRequired,
  origin: PropTypes.array.isRequired,
  onClick: PropTypes.func,
  options: PropTypes.shape({
    period: PropTypes.number.isRequired,
    movingAverageType: PropTypes.string.isRequired,
    shiftType: PropTypes.string.isRequired,
    shift: PropTypes.number.isRequired,
  }).isRequired,
  textFill: PropTypes.string,
  labelFill: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
};

MAEnvelopeTooltip.defaultProps = {
  className: "react-stockcharts-tooltip react-stockcharts-maenvelope-tooltip",
  displayFormat: format(".2f"),
  displayValuesFor: displayValuesFor,
  origin: [0, 10],
};

export default MAEnvelopeTooltip;
